import { useQuery } from 'react-query';

import { Topic } from '../../../types/Topic';
import Api from '../../api/api';

export const getTopic = async (topicId: string): Promise<Topic> => {
  const [response, bodyOrError] = await Api.get(`topics/${topicId}`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useGetTopic = (topicId: string) =>
  useQuery(['getTopic', topicId], () => getTopic(topicId), {
    enabled: topicId !== 'new' || !!topicId,
  });
